/*
 * @description: 系统路由配置
 * @author: xuy
 * @since: 2020-03-31 11:03:46
 * @version: 1.0
 */
import Layout from '@/framework/layout/BaseLayout.vue'
import PublicLayout from '@/framework/layout2/PublicLayout.vue'
export default [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/app/system-mgt/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/app/system-mgt/views/login/index'),
    hidden: true,
    meta: { whiteList: true}
  },
  {
    path: '/auth-redirect',
    component: () => import('@/app/system-mgt/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/app/system-mgt/views/error-page/404'),
    hidden: true,
    meta: { title: 'Document', icon: 'dashboard', authUrl: ''}
  },
  {
    path: '/401',
    component: () => import('@/app/system-mgt/views/error-page/401'),
    hidden: true,
    meta: { title: 'Document', icon: 'dashboard', authUrl: ''}
  },
  {
    path: '/',
    redirect: '/index',
    component: PublicLayout,
    children: [
      // 首页
      {
        path: 'index',
        component: () => import('@/app/home/views/index'),
        name: 'Index',
        meta: { title: 'module.isp-main.098675-0', icon: 'guide', keepAlive: true,breadcrumb:true,whiteList:true}
      },
      // 使用指南
      {
        path: 'guide-to-use',
        component: () => import('@/app/guide-to-use/views/index'),
        name: 'GuideToUse',
        meta: { title: 'module.isp-main.098675-1', icon: 'guide', keepAlive: true}
      }
    ]
  },
  {
    path: '/home',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: 'system-settings/user-settings',
        component: () => import('@/app/system-settings/views/user-management/user-settings/index'),
        name: 'UserSettings',
        meta: { title: 'module.isp-main.098675-2', icon: 'guide', authUrl: '', keepAlive: true }
      }
    ]
  },
  {
    path: '/use-case',
    component: Layout,
    children: [
      {
        path: 'request',
        component: () => import('@/app/system-mgt/views/use-case/request'),
        name: 'Request'
      }
    ]
  },
  {
    path: '/system-settings',
    component: Layout,
    children: [
      {
        path: 'role-management',
        component: () => import('@/app/system-settings/views/role-management/index'),
        name: 'RoleManagement',
        meta: { title: 'module.isp-main.098675-3', icon: '', noCache: true }
      },
      {
        path: 'user-management',
        component: () => import('@/app/system-settings/views/user-management/index'),
        name: 'UserManagement',
        meta: { title: 'module.isp-main.098675-4', icon: '', noCache: true }
      },
      {
        path: 'audit-management',
        component: () => import('@/app/system-settings/views/audit-management/index'),
        name: 'AuditManagement',
        meta: { title: 'module.isp-main.098675-5', icon: '', noCache: true }
      },
      {
        path: 'category-management',
        component: () => import('@/app/system-settings/views/category-management/index'),
        name: 'CategoryManagement',
        meta: { title: 'module.isp-main.098675-6', icon: '', noCache: true }
      }
    ]
  },
  {
    path: "/reconciliationCenter",
    component: PublicLayout,
    meta: {
      title: 'module.isp-main.098675-7',
      icon: "guide",
      // keepAlive: true,
    },
    children: [
      {
        path: "index",
        component: () => import("@/app/home/views/reconciliationCenter/index"),
        name: "reconciliationCenter",
        meta: {
          title: 'module.isp-main.098675-7',
          icon: "guide",
          // keepAlive: true,
          breadcrumb: true,
        },
      },
    ],
  },
  {
    path: "/invoiceUpload",
    component: PublicLayout,
    meta: {
      title: 'module.isp-main.098675-8',
      icon: "guide",
      // keepAlive: true,
    },
    children: [
      {
        path: "index",
        component: () => import("@/app/home/views/invoiceUpload/index"),
        name: "invoiceUpload",
        meta: {
          title: 'module.isp-main.098675-8',
          icon: "guide",
          keepAlive: true,
          breadcrumb: true,
        },
      },
    ],
  },
  { path: '*', redirect: '/404', hidden: true }
]

